<script lang="ts" setup>
const _props = defineProps<{
  link: LinkProps
}>()
</script>

<template>
  <CommonBasicLink
    :link="link"
    class="relative inline-block px-3 py-2 font-mono text-sm uppercase transition-all before:absolute before:inset-0 before:z-0 before:transition-transform before:duration-500 before:ease-out hover:tracking-wider hover:before:scale-x-[1.1] hover:before:-skew-x-[20deg]"
  >
    <span class="relative z-[1]">
      {{ link.title }}
    </span>
  </CommonBasicLink>
</template>
